
<div
  class="nav-item dropdown d-inline-block"
  ngbDropdown
  #navUserIconDropdown="ngbDropdown"
  display="static"
>
  <div class="d-flex">
    <button
      class="bg-transparent border-0"
      (click) ="navUserIconDropdown.toggle()"
    >
      <!--<app-st-profile-picture size="sm" [outline]="false"></app-st-profile-picture>-->
    </button>
    <div class="d-flex flex-column justify-content-center">
      <span>{{userDisplayName}}</span>
      <span class="text-muted">{{userPositionTitle}}</span>
    </div>
  </div>
  <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end">
    <button ngbDropdownItem role="button" (click)="goToProfile()">
      <i class="i icon bi-person"></i>
      Profile
    </button>
    <div class="dropdown-divider"></div>
    <button ngbDropdownItem role="button" (click)="logout()">
      <i class="i icon bi-box-arrow-right"></i>
      Log out
    </button>
  </div>
</div>
